export default __webpack_public_path__ + "static/media/0xda9c093a7d9e41d21dc9a7ff5601a3fd02111d95.673c4983.png";